import { useSelector } from "react-redux";
import MessageEventList from "go-component/components/MessageEvent/MessageEventList";
import { apiOrganization } from "go-security/services/Api/apiOrganization";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationLogsMessageEventsIndexPage = () => {
	const organization = useSelector(selectOrganization);

	return (
		<MessageEventList
			organization_name={organization?.name ?? ""}
			organizationId={organization?.id}
			userSearchSelectRequest={apiOrganization.getUsersSearchSelect.bind(apiOrganization)}
		/>
	);
};

export default OrganizationLogsMessageEventsIndexPage;
